// extracted by mini-css-extract-plugin
module.exports = {"searchViewStyleWrapper":"SearchView_searchViewStyleWrapper__IBVCz"};